const MAINTENANCE_MODE_STATUS = {
    active: 'enabled',
    disable: 'disabled ',
}

export {
    MAINTENANCE_MODE_STATUS,
}
